import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Types
import { FailedCall } from '../../../shared/types/manageCalls';
import { BY_PRODUCER, TOREPRODUCE } from '../../../shared/types/toReproduce';

// Services
import { WebServiceCaller } from '../../services/webservice-caller/webservice-caller.service';

@Injectable()
export class ToReproduceService {
  private RESOURCE = 'toReproduce/';

  private readonly wsCaller = inject(WebServiceCaller);

  getWineAndSpiritsList(): Observable<Array<TOREPRODUCE> | FailedCall> {
    return this.wsCaller.postCall(this.RESOURCE + 'wineAndSpiritsList');
  }

  getByProducers(): Observable<Array<TOREPRODUCE> | FailedCall> {
    return this.wsCaller.postCall(this.RESOURCE + 'byProducers');
  }

  getToReproduce(ID: number): Observable<TOREPRODUCE | FailedCall> {
    return this.wsCaller.postCall('toReproduce', { ID });
  }

  getByProducersChoice(ID: number): Observable<BY_PRODUCER | FailedCall> {
    return this.wsCaller.postCall(this.RESOURCE + 'byProducersChoice', { ID });
  }
}
